import type { SxProps, Theme } from '@mui/material';

export const styles = {
    alert: { width: '100%' } as SxProps<Theme>,
};
